import { postRequest } from '@/core';
import { cargoCarrierTypes } from '@/requests';

export default async function syncCargoCarrierTypes() {

	let url = cargoCarrierTypes.getSyncPath();

	try {
		return await postRequest(url);

	} catch (err) {
		if (err.response && err.response.data) {

			throw new Error(err.response.data);
		}
		throw err;
	}
}